import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-468e7b5c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "van-doc-card",
  id: "posterHtml"
};
const _hoisted_2 = ["src", "data-name", "data-url"];
const _hoisted_3 = {
  key: 1,
  class: "content"
};
const _hoisted_4 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Use Mobile Scan code to pay", -1));

const _hoisted_6 = {
  class: "qrnote"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "qrcodegroup"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrnote2"
}, [/*#__PURE__*/_createElementVNode("div", null, "1. If payment fails, please change payment APP and Scan Qr to pay again"), /*#__PURE__*/_createElementVNode("div", null, "2. Same QR can only be pay successfully once")], -1));

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Save and to pay ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue");

  const _component_van_image = _resolveComponent("van-image");

  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$data.posterImg !== '' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.posterImg,
    id: "posterimg",
    "data-name": $data.orderinfo.merchant_orderno + '.png',
    "data-url": 'https://indshop.one/qrcode/' + $data.orderno
  }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [$data.posterContent !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($data.posterContent), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, "OrderID: " + _toDisplayString($data.orderinfo.merchant_orderno), 1), _createElementVNode("div", null, "Amount: " + _toDisplayString($data.amount), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_qrcode_vue, {
    value: $data.qvalue,
    size: $data.size,
    id: "qrcode",
    level: "H"
  }, null, 8, ["value", "size"])]), _hoisted_9, _createVNode(_component_van_image, {
    src: "/assets/icon/upis.png"
  })])]))]), _createVNode(_component_van_button, {
    type: "primary",
    class: "cofbutton",
    onClick: $options.imgDown
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["onClick"])], 64);
}